import "flickity/dist/flickity.min.css";

let defaultOps = {
  accessibility: false,
  adaptiveHeight: false,
  pauseAutoPlayOnHover: true,
  autoPlay: 3000,
  cellAlign: "center",
  cellSelector: ".floor-plan__slide",
  contain: false,
  draggable: true,
  dragThreshold: 0,
  groupCells: false,
  initialIndex: 0,
  prevNextButtons: true,
  percentPosition: true,
  pageDots: false,
  resize: true,
  setGallerySize: true,
  wrapAround: true
};

const flickFloor = () => {
  let flky = new Flickity(".floor-plan__slider", { ...defaultOps })
  let utils = window.fizzyUIUtils;
  let cellsButtonGroup = document.querySelector('.floor-plan__text-slides');
  let cellsButtons = utils.makeArray( cellsButtonGroup.children );

  // update buttons on select
  flky.on('select', function() {
    let previousSelectedButton = cellsButtonGroup.querySelector('.floor-plan__text--active');
    let selectedButton = cellsButtonGroup.children[ flky.selectedIndex ];
    previousSelectedButton.classList.remove('floor-plan__text--active');
    selectedButton.classList.add('floor-plan__text--active');
  });
};

const FloorSlider = () => {
  let element = document.querySelector(".floor-plan__slider");
  if (typeof element != "undefined" && element != null)
    flickFloor();
};

export default FloorSlider;


// WEBPACK FOOTER //
// ./src/js/app/components/FloorSlider.js